import React, { useEffect, useState } from 'react';
import Reveal from 'react-awesome-reveal';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Import Custom Component
import { EmblaCarousel } from '../../features/carousel/emblaCarousel';

// Import Keyframes
import {
  fadeInLeftShorter,
  slideInRight,
  fadeInUpShorter
} from '../../../utils/data/keyframes';
import { useRouter } from 'next/router';
import useApproveModalStore from '../../../store/approve-modal';

function HomeSection() {
  const router = useRouter();
  const { openModal } = useApproveModalStore();
  const [isMobileView, setIsMobileView] = useState(false);

  const updateQueryParams = () => {
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          modal: true
        }
      },
      undefined,
      { shallow: true }
    );
  };

  const handleResize = () => {
    setIsMobileView(window.innerWidth <= 560);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize());
    };
  }, []);

  return (
    <div className="home-slider-container-embla">
      <EmblaCarousel
        options={{ loop: true, align: 'start' }}
        autoPlay={true}
        showButtons={true}
        totalSlides={4}
        slidesToScroll={1}>
        <div className="home-slider">
          <div className="home-slide">
            <figure>
              <LazyLoadImage
                className="slide-bg"
                alt="slider image"
                src="/images/banners/slide1.jpg"
                width="100%"
                height="auto"
                style={{
                  objectFit: 'cover'
                }}
              />
            </figure>
            <div className="home-slide-content sale-banner">
              <Reveal keyframes={fadeInLeftShorter} delay={100} duration={1000}>
                <div className="row no-gutter bg-transparent">
                  <div className="col-md-6 d-flex flex-column justify-content-start">
                    <Reveal
                      keyframes={slideInRight}
                      delay={400}
                      duration={1000}>
                      <h3 className="align-left text-uppercase ">
                        The nation's leading provider in lease-to-own furniture
                      </h3>
                    </Reveal>
                    <div className={'col-lg-7 pl-0'}>
                      <Reveal
                        keyframes={slideInRight}
                        delay={400}
                        duration={1000}>
                        <h4 className="mb-0 text-dark banner-text">
                          Get Approved Instantly for up to <b>$5,000</b> in
                          brand named furniture shipped to your doorstep.
                        </h4>
                      </Reveal>
                    </div>
                  </div>
                </div>
              </Reveal>
              <div className="mb-0">
                <Reveal keyframes={fadeInUpShorter} delay={600} duration={1000}>
                  <a
                    target="_blank"
                    onClick={openModal}
                    className="btn btn-lg btn-dark approved-button">
                    Get Approved!
                  </a>
                </Reveal>
              </div>
            </div>
          </div>

          <div className="home-slide">
            <figure>
              <LazyLoadImage
                className="slide-bg"
                alt="slider image"
                src="/images/banners/slide2.jpg"
                width="100%"
                height="auto"
                style={{
                  objectFit: 'cover'
                }}
              />
            </figure>
            <div className="home-slide-content sale-banner">
              <Reveal keyframes={fadeInLeftShorter} delay={100} duration={1000}>
                <div className="row no-gutter bg-transparent">
                  <div className="col-md-12 d-flex flex-column justify-content-start">
                    <Reveal
                      keyframes={slideInRight}
                      delay={400}
                      duration={1000}>
                      <h3 className="align-left text-uppercase ">
                        Dining and kitchen sets
                      </h3>
                    </Reveal>
                    <div className={'col-lg-7 pl-0'}>
                      <Reveal
                        keyframes={slideInRight}
                        delay={400}
                        duration={1000}>
                        <h4 className="mb-0 text-dark banner-text">
                          You will love our reasonably priced dining sets and
                          accessories.
                        </h4>
                      </Reveal>
                    </div>
                  </div>
                </div>
              </Reveal>
              <div className="mb-0">
                <Reveal keyframes={fadeInUpShorter} delay={600} duration={1000}>
                  <a
                    target="_blank"
                    onClick={openModal}
                    className="btn btn-lg btn-dark approved-button">
                    Get Approved!
                  </a>
                </Reveal>
              </div>
            </div>
          </div>

          <div className="home-slide">
            <figure>
              <LazyLoadImage
                className="slide-bg"
                alt="slider image"
                src="/images/banners/slide3.jpg"
                width="100%"
                height="auto"
                style={{
                  objectFit: 'cover'
                }}
              />
            </figure>
            <div className="home-slide-content sale-banner">
              <Reveal keyframes={fadeInLeftShorter} delay={100} duration={1000}>
                <div className="row no-gutter bg-transparent">
                  <div className="col-md-8 d-flex flex-column justify-content-start">
                    <Reveal
                      keyframes={slideInRight}
                      delay={400}
                      duration={1000}>
                      <h3 className="align-left text-uppercase ">
                        Bedroom sets
                      </h3>
                    </Reveal>
                    <div className={'col-lg-7 pl-0'}>
                      <Reveal
                        keyframes={slideInRight}
                        delay={400}
                        duration={1000}>
                        <h4 className="mb-0 text-dark banner-text">
                          Maximize your living space with stylish storage and
                          beautiful simplicity.
                        </h4>
                      </Reveal>
                    </div>
                  </div>
                </div>
              </Reveal>
              <div className="mb-0">
                <Reveal keyframes={fadeInUpShorter} delay={600} duration={1000}>
                  <a
                    target="_blank"
                    onClick={openModal}
                    className="btn btn-lg btn-dark approved-button">
                    Get Approved!
                  </a>
                </Reveal>
              </div>
            </div>
          </div>

          <div className="home-slide">
            <figure>
              <LazyLoadImage
                className="slide-bg"
                alt="slider image"
                src="/images/banners/slide4.jpg"
                width="100%"
                height="auto"
                style={{
                  objectFit: 'cover'
                }}
              />
            </figure>
            <div className="home-slide-content sale-banner">
              <Reveal keyframes={fadeInLeftShorter} delay={100} duration={1000}>
                <div className="row no-gutter bg-transparent">
                  <div className="col-md-8 d-flex flex-column justify-content-start">
                    <Reveal
                      keyframes={slideInRight}
                      delay={400}
                      duration={1000}>
                      <h3 className="align-left text-uppercase ">
                        Sofas & sectionals
                      </h3>
                    </Reveal>
                    <div className={'col-lg-7 pl-0'}>
                      <Reveal
                        keyframes={slideInRight}
                        delay={400}
                        duration={1000}>
                        <h4 className="mb-0 text-dark banner-text">
                          Make your home inviting with stunning sofas,
                          sectionals, loveseats and more.
                        </h4>
                      </Reveal>
                    </div>
                  </div>
                </div>
              </Reveal>
              <div className="mb-0">
                <Reveal keyframes={fadeInUpShorter} delay={600} duration={1000}>
                  <a
                    target="_blank"
                    onClick={openModal}
                    className="btn btn-lg btn-dark approved-button">
                    Get Approved!
                  </a>
                </Reveal>
              </div>
            </div>
          </div>
        </div>
      </EmblaCarousel>

      <EmblaCarousel
        options={{ loop: true, align: 'start', watchDrag: false }}
        autoScroll={true}>
        <div className="home-sect-container">
          <div className="home-sect-card">
            <LazyLoadImage
              width={56}
              height={56}
              src="/images/home/iconNoCredit.svg"
            />
            <span className={'ml-4'}>Bad credit or No credit - OK</span>
          </div>
          <div className="home-sect-card">
            <LazyLoadImage
              width={56}
              height={56}
              src="/images/home/approveIcon.svg"
            />
            <span className={'ml-4'}>Get approved for up to $5,000</span>
          </div>
          <div className="home-sect-card">
            <LazyLoadImage
              width={56}
              height={56}
              src="/images/home/deliveryIcon.svg"
            />
            <span className={'ml-4'}>
              Furniture shipped directly to your home
            </span>
          </div>
          <div className="home-sect-card">
            <LazyLoadImage
              width={56}
              height={56}
              src="/images/home/nationIcon.svg"
            />
            <span className={'ml-4'}>Available nationwide</span>
          </div>
          <div className="home-sect-card">
            <LazyLoadImage
              width={56}
              height={56}
              src="/images/home/support.svg"
            />
            <span className={'ml-4'}>Call or chat with us online!</span>
          </div>
          <div className="home-sect-card">
            <LazyLoadImage
              width={56}
              height={56}
              src="/images/home/prices.svg"
            />
            <span className={'ml-4'}>Everyday Low Prices</span>
          </div>
          <div className="home-sect-card">
            <LazyLoadImage width={56} height={56} src="/images/home/like.svg" />
            <span className={'ml-4'}>
              Over 1 Million new, brand name, products
            </span>
          </div>
        </div>
      </EmblaCarousel>
    </div>
  );
}

export default React.memo(HomeSection);
